import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AngularFireModule } from '@angular/fire'; // Firebase config
import { AngularFirestoreModule } from '@angular/fire/firestore'; // For Cloud Firestore
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from 'src/environments/environment'; // Config
import { AngularFireMessagingModule } from '@angular/fire/messaging';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxBootstrapConfirmModule } from 'ngx-bootstrap-confirm';

import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InicioComponent } from './inicio/inicio.component';
import { PrivacidadComponent } from './privacidad/privacidad.component';
import { MenuComponent } from './menu/menu.component';
import { LoginComponent } from './autenticacion/login/login.component';

import { EntrenamientosComponent } from './entrenamientos/entrenamientos.component';

import { TemporadaListComponent } from './catalogos/temporadas/temporada-list/temporada-list.component';
import { TemporadaFormComponent } from './catalogos/temporadas/temporada-form/temporada-form.component';

import { CategoriaListComponent } from './catalogos/categorias/categoria-list/categoria-list.component';
import { CategoriaFormComponent } from './catalogos/categorias/categoria-form/categoria-form.component';

import { EquipoListComponent } from './catalogos/equipos/equipo-list/equipo-list.component';
import { EquipoFormComponent } from './catalogos/equipos/equipo-form/equipo-form.component';

import { CompeticionListComponent } from './catalogos/competiciones/competicion-list/competicion-list.component';
import { CompeticionFormComponent } from './catalogos/competiciones/competicion-form/competicion-form.component';

import { RolListComponent } from './catalogos/roles/rol-list/rol-list.component';
import { RolFormComponent } from './catalogos/roles/rol-form/rol-form.component';

import { UsuarioListComponent } from './personas/usuarios/usuario-list/usuario-list.component';
import { UsuarioFormComponent } from './personas/usuarios/usuario-form/usuario-form.component';

import { CompeticionesListComponent } from './competiciones/competiciones/competicion-list/competicion-list.component';
import { AgendaListComponent } from './agenda/agenda/agenda-list/agenda-list.component';

import { MessagingService } from './messaging/services/messaging.service';
import { AsyncPipe } from '../../node_modules/@angular/common';

@NgModule({
    declarations: [
        AppComponent,
        InicioComponent,
        PrivacidadComponent,
        MenuComponent,
        LoginComponent,
        EntrenamientosComponent,
        TemporadaListComponent,
        TemporadaFormComponent,
        CategoriaListComponent,
        CategoriaFormComponent,
        EquipoListComponent,
        EquipoFormComponent,
        CompeticionListComponent,
        CompeticionFormComponent,
        RolListComponent,
        RolFormComponent,
        UsuarioListComponent,
        UsuarioFormComponent,
        CompeticionesListComponent,
        AgendaListComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AngularFireModule.initializeApp(environment.firebaseConfig), // Import firebase
        AngularFirestoreModule, // Import firestore
        AngularFireAuthModule,
        AngularFireMessagingModule,
        AppRoutingModule,
        NgbModule,
        ReactiveFormsModule,
        NgxBootstrapConfirmModule,
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        MessagingService,AsyncPipe],
    bootstrap: [AppComponent],
    entryComponents: [TemporadaFormComponent]
})
export class AppModule { }
